import { gsap, ScrollTrigger } from "@/composeables/gsap"
import { VerticalOverlapObserver } from "@/vanilla/VerticalOverlapObserver";

function createCollisionAnimation(section) {
    const qs = gsap.utils.selector(section)
    const dqs = (selector) => document.querySelector(selector)
    const actions = qs(".section-product-teaser__actions").find(Boolean)
    const cta = qs(".section-product-teaser__actions .cta").find(Boolean)
    const navigation = dqs('.the-navigation')
    const navigationWrapper = dqs('.the-navigation-wrapper')

    const ease = "none"

    const ctaWidth = () => cta.getBoundingClientRect().width

    const tl = gsap
            .timeline({ paused: true })
            .to(navigationWrapper, { width: () => ctaWidth(), duration: 1, ease })
            .fromTo(navigation, { opacity: 1 }, { opacity: 0, duration: 1, ease })

    const observer = new VerticalOverlapObserver((entries) => {
        entries.forEach(({ element, ratio, target, other }) => {
            tl.progress(ratio)
        });

    }, navigation)

    observer.observe(cta, { startOffset: 0, endOffset: 0 })
}
function createFloatingBarAnimation(section) {
    const qs = gsap.utils.selector(section)
    const dqs = (selector) => document.querySelector(selector)
    const actions = qs(".section-product-teaser__actions")
    const cta = qs(".section-product-teaser__actions .cta").find(Boolean)
    const navigation = dqs('.the-navigation')


    const duration = 0.3
    const ease = "expo.inOut"

    const ctaWidth = () => cta.getBoundingClientRect().width

    const trigger = ScrollTrigger.create({
        trigger: actions,
        anticipatePin: 1,
        // start() { return "top bottom-=52px" },
        // end() { return `bottom bottom-=104px` },
        start() {
            return `top top+=${window.visualViewport.height-52}`
        },
        end() {
            return `bottom top+=${window.visualViewport.height-104}`
        },
        invalidateOnRefresh: true,
        markers: false,
        onEnter() {
            gsap.to(navigation, { autoAlpha: 0, y: 0, width: () => ctaWidth(), duration, ease })
        },
        onLeave() {
            gsap.to(navigation, { autoAlpha: 1, y: 0, width: 'auto', duration, ease })
        },
        onEnterBack() {
            gsap.to(navigation, { autoAlpha: 0, y: 0, width: () => ctaWidth(), duration, ease })
        },
        onLeaveBack() {
            gsap.to(navigation, { autoAlpha: 1, y: 0, width: 'auto', duration, ease })
        },
    })

    window.addEventListener(
        'scroll',
        () => {
            if (trigger.isActive) return
            trigger.refresh()
        },
        { passive: true }
    )

    if (trigger.isActive) {
        gsap.set(navigation, { autoAlpha: 0 })
    }
}

function createMediaAnimation(section) {
    const qs = gsap.utils.selector(section)
    const media = qs(".section-product-teaser__media")

    const tweenMedia = gsap.fromTo(
        media,
        { y: '+=50%', scale: 1.2, },
        { y: 0, scale: 1, duration: 1.1 }
    );

    const timeline = gsap
        .timeline()
        .add(tweenMedia)
        .addLabel("end")

    ScrollTrigger.create({
        trigger: media,
        endTrigger: section,
        markers: false,
        start: "top bottom",
        end: "90% bottom",
        invalidateOnRefresh: true,
        animation: timeline,
        scrub: true,
    });
}

function createFeaturesAnimation(section) {
    const qs = gsap.utils.selector(section)
    const features = qs(".section-product-teaser__features")
    const featureTexts = qs(".section-product-teaser__features .text")

    const tweenTexts = gsap.fromTo(
        featureTexts,
        {
            autoAlpha: 0,
            y: '+=20cqw',
        },
        {
            autoAlpha: 1,
            y: 0,
            overwrite: true,
            ease: "expo",
            stagger: 0.1,
            duration: 1
        }
    )

    const timeline = gsap.timeline()
        .set(featureTexts, { autoAlpha: 0 })
        .add(tweenTexts)

    ScrollTrigger.create({
        trigger: features,
        markers: false,
        start: "top center",
        end: "bottom center",
        invalidateOnRefresh: true,
        animation: timeline,
        scrub: true,
    });
}

function createPillAnimation(section) {
    const qs = gsap.utils.selector(section)
    const product = qs(".section-product-teaser__product")
    const productImg = qs(".section-product-teaser__product img")

    const tween = gsap.fromTo(productImg,
        { scale: 6 },
        { scale: 1 }
    );

    const timeline = gsap.timeline()
        .set(productImg, { transformOrigin: 'top center' })
        .set(product, { transformOrigin: 'top center', overflow: 'visible' })
        .add(tween)

    ScrollTrigger.create({
        trigger: section,
        endTrigger: product,
        start: "top bottom",
        end: "center center",
        markers: false,
        scrub: true,
        animation: timeline,
        invalidateOnRefresh: true,
    })

}

export const init = () => {
    const sections = gsap.utils.toArray(".section-product-teaser");

    sections
        .forEach(createPillAnimation)

    sections
        .forEach(createFeaturesAnimation)

    sections
        .forEach(createMediaAnimation)

    // sections
    //     .forEach(createCollisionAnimation)
};

export default init;
